import { AddEditComponent } from "./../mystery-shopper/mysteryshopper-whitelist-outlets/add-edit/add-edit.component";
import { MysteryshopperWhitelistOutletsComponent } from "./../mystery-shopper/mysteryshopper-whitelist-outlets/mysteryshopper-whitelist-outlets.component";
import { CreateMysteryShopperComponent } from "./../mystery-shopper/create-mystery-shopper/create-mystery-shopper.component";
import { GapAnalysisComponent } from "./../gap-analysis/gap-analysis.component";
import { PointAccountStatementComponent } from "./../reports/point-account-statement/point-account-statement.component";
import { Routes } from "@angular/router";
import { StatesComponent } from "../masterData/states/states.component";
import { UsersComponent } from "../userManagement/users/users.component";
import { UsersProfilesComponent } from "../userManagement/users-profiles/users-profiles.component";
import { OutletTypeHierarchyComponent } from "../userManagement/outlet-type-hierarchy/outlet-type-hierarchy.component";
import { GeographicalHierarchyComponent } from "../userManagement/geographical-hierarchy/geographical-hierarchy.component";
import { GeneralReportsComponent } from "../../hubadmin/reports/general-reports/general-reports.component";
import { RegionComponent } from "../../hubadmin/masterData/region/region.component";
import { ProductsComponent } from "../ecommerce/products/products.component";
import { RolesComponent } from "../../hubadmin/masterData/roles/roles.component";
// import { CampaignComponent } from "../campaign/campaign/campaign.component";
import { BrandCategoriesComponent } from "../masterData/brand-categories/brand-categories.component";
import { BrandsComponent } from "../masterData/brands/brands.component";
import { ChanelComponent } from "../masterData/chanel/chanel.component";
import { CitiesComponent } from "../masterData/cities/cities.component";
import { FrequencyComponent } from "../masterData/frequency/frequency.component";
import { LanguagesComponent } from "../masterData/languages/languages.component";
import { ModulesComponent } from "../masterData/modules/modules.component";
import { UnitsComponent } from "../masterData/units/units.component";
// import { EngagementConfigComponent } from "../engagement-config/engagement-config.component";
import { ListOrderComponent } from "../order-management/list-order/list-order.component";
import { DetailsOrderComponent } from "../order-management/details-order/details-order.component";
import { RewardCategoriesComponent } from "../../hubadmin/rewards/reward-categories/reward-categories.component";
import { RewardSubCategoriesComponent } from "../../hubadmin/rewards/reward-sub-categories/reward-sub-categories.component";
import { RewardTypesComponent } from "../../hubadmin/rewards/reward-types/reward-types.component";
import { RewardProductsComponent } from "../../hubadmin/rewards/reward-products/reward-products.component";
// import { EngagementDashboardComponent } from "../engagement-config/engagement-dashboard/engagement-dashboard.component";
import { RewardHistoryComponent } from "../../hubadmin/rewards/reward-history/reward-history.component";
import { CartonsListComponent } from "../../hubadmin/carton/cartons-list/cartons-list.component";
import { SchemesListComponent } from "../../hubadmin/schemes/schemes-list/schemes-list.component";
import { SchemeConfigurationComponent } from "../../hubadmin/schemes/scheme-configuration/scheme-configuration.component";
import { EditUserComponent } from "../userManagement/edit-user/edit-user.component";
import { ProductEditComponent } from "../ecommerce/product-edit/product-edit.component";
import { ProductAddComponent } from "../../hubadmin/ecommerce/product-add/product-add.component";
import { VisibilityListComponent } from "../visibility/visiblity-audit-configurations/visibility-list/visibility-list.component";
import { VisibilityConfigListComponent } from "../visibility/visiblity-audit-configurations/visibility-config-list/visibility-config-list.component";
import { VisibilityConfigAddComponent } from "../visibility/visiblity-audit-configurations/visibility-config-add/visibility-config-add.component";
import { VisibilitySubmissionsComponent } from "../../hubadmin/visibility/visibility-submissions/visibility-submissions.component";
import { VisibilityElementAddComponent } from "../../hubadmin/visibility/visibility-element-add/visibility-element-add.component";
import { VisibilityElementEditComponent } from "../../hubadmin/visibility/visibility-element-edit/visibility-element-edit.component";
import { CampaignCreationComponent } from "../campaign/campaign-creation/campaign-creation.component";
import { ListOfferComponent } from "../ecommerce/list-offer/list-offer.component";
import { ListCategoryComponent } from "../order-management/list-category/list-category.component";
import { EditCategoryComponent } from "../order-management/edit-category/edit-category.component";
import { CartonCodesComponent } from "../../hubadmin/carton/carton-codes/carton-codes.component";
// import { ContentAndLearningComponent } from "../content-and-learning/content-and-learning.component";
// import { AddContentAndLearningComponent } from "../content-and-learning/add-content-and-learning/add-content-and-learning.component";
import { GetVisitsComponent } from "../visit-tracker/get-visits/get-visits.component";
import { CreateVisitsComponent } from "../visit-tracker/create-visits/create-visits.component";
import { GetEnrollmentComponent } from "../visit-tracker/get-enrollment/get-enrollment.component";
import { EnrollUserComponent } from "../../hubadmin/userManagement/enroll-user/enroll-user.component";
import { CreateEnrollmentComponent } from "../visit-tracker/create-enrollment/create-enrollment.component";
import { AddCategoryComponent } from "../../hubadmin/order-management/add-category/add-category.component";

// import { GeographyComponent } from '../../hubadmin/masterData/geography/geography.component';
import { ViewEnrollmentComponent } from "../visit-tracker/view-enrollment/view-enrollment.component";
import { WhitelistingComponent } from "../masterData/whitelisting/whitelisting.component";
import { AddOfferComponent } from "../ecommerce/add-offer/add-offer.component";

import { UpdateOfferComponent } from "../order-management/update-offer/update-offer.component";
import { AddTargetAchievementsComponent } from "../target-achievements/add-target-achievements/add-target-achievements.component";
import { ListTargetAchievementsComponent } from "../target-achievements/list-target-achievements/list-target-achievements.component";
import { CreateProductComponent } from "../rewards/reward-products/create-product/create-product.component";
import { EditProductComponent } from "../rewards/reward-products/edit-product/edit-product.component";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { CreateUserComponent } from "../userManagement/create-user/create-user.component";
import { GetBeatsComponent } from "../../hubadmin/visit-tracker/get-beats/get-beats.component";
import { VisibilityConfigEditComponent } from "../../hubadmin/visibility/visibility-config-edit/visibility-config-edit.component";

import { LayoutComponent } from "./layout.component";
import { UserPointsComponent } from "../user-points/user-points.component";
import { ChillerSelectionComponent } from "../visibility/chiller/chiller-selection/chiller-selection.component";
import { ChillerSchemeComponent } from "../visibility/chiller/chiller-scheme/chiller-scheme.component";
import { VisiblityAuditTypesComponent } from "../visibility/visiblity-templates/visiblity-audit-types/visiblity-audit-types.component";
import { AddEditVisiblityTemplateComponent } from "../visibility/visiblity-templates/add-edit-visiblity-template/add-edit-visiblity-template.component";
import { GeoGroupComponent } from "../userManagement/geo-group/geo-group.component";
import { GeoGroupAddEditComponent } from "../userManagement/geo-group/geo-group-add-edit/geo-group-add-edit.component";
import { GeoUserComponent } from "../userManagement/geo-user/geo-user.component";
import { CoolerElementsComponent } from "../visibility/cooler-elements/cooler-elements.component";
import { CoolerAuditTypesComponent } from "../visibility/visiblity-templates/cooler-audit-types/cooler-audit-types.component";
import { AddEditCoolerAuditTypeComponent } from "../visibility/visiblity-templates/add-edit-cooler-audit-type/add-edit-cooler-audit-type.component";
import { ImageurlsComponent } from "../masterData/imageurls/imageurls.component";
import { CoolerConfigListComponent } from "../visibility/visiblity-audit-configurations/cooler-config-list/cooler-config-list.component";
import { CoolerConfigAddComponent } from "../visibility/visiblity-audit-configurations/cooler-config-add/cooler-config-add.component";
import { AddChillerSchemeComponent } from "../visibility/chiller/add-chiller-scheme/add-chiller-scheme.component";
import { MobileChangeReportComponent } from "../reports/mobile-change-report/mobile-change-report.component";
import { EnrollementDetailedReportComponent } from "../reports/enrollement-detailed-report/enrollement-detailed-report.component";
import { HomeComponent } from "../reports/home/home.component";
import { AccountStatementComponent } from "../reports/account-statement/account-statement.component";
import { Bud4tradeReportComponent } from "../reports/bud4trade-report/bud4trade-report.component";
import { MysteryReportComponent } from "../reports/mystery-report/mystery-report.component";
import { RedmeptionReportComponent } from "../reports/redmeption-report/redmeption-report.component";
import { TargetAchivementsReportComponent } from "../reports/target-achivements-report/target-achivements-report.component";
import { CompiledStatewiseReportComponent } from "../reports/compiled-statewise-report/compiled-statewise-report.component";
import { EndOfReportComponent } from "../reports/end-of-report/end-of-report.component";
import { LivepointReportComponent } from "../reports/livepoint-report/livepoint-report.component";
import { DauReportComponent } from "../reports/dau-report/dau-report.component";
import { EngagementReportComponent } from "../reports/engagement-report/engagement-report.component";
import { MauTimeReportComponent } from "../reports/mau-time-report/mau-time-report.component";
import { ModuleTimeReportComponent } from "../reports/module-time-report/module-time-report.component";
import { SchemeReportComponent } from "../reports/scheme-report/scheme-report.component";
import { UpliftReportComponent } from "../reports/uplift-report/uplift-report.component";
import { LeaderReportComponent } from "../reports/leader-report/leader-report.component";
import { OtherReportComponent } from "../reports/other-report/other-report.component";
import { EngagementStatementReportComponent } from "../reports/engagement-statement-report/engagement-statement-report.component";
import { HubRedemptionReportComponent } from "../reports/hub-redemption-report/hub-redemption-report.component";
import { PointExpiryRulesComponent } from "../point-expiry-rules/point-expiry-rules.component";
import { AddEditPointExpiryRuleComponent } from "../point-expiry-rules/add-edit-point-expiry-rule/add-edit-point-expiry-rule.component";
import { GapAnalysisNewUserComponent } from "../gap-analysis-new-user/gap-analysis-new-user.component";
import { MenuSpocEmailComponent } from "../menu-spoc-email/menu-spoc-email.component";
import { MysteryshopperQuestionBankComponent } from "../mystery-shopper/mysteryshopper-question-bank/mysteryshopper-question-bank.component";
import { MysteryshopperTemplatesComponent } from "../mystery-shopper/mysteryshopper-templates/mysteryshopper-templates.component";
import { AddEditTemplatesComponent } from "../mystery-shopper/mysteryshopper-templates/add-edit-templates/add-edit-templates.component";
import { AddCrownTargetComponent } from "../crown-target/add-crown-target/add-crown-target.component";
import { ListCrownTargetComponent } from "../crown-target/list-crown-target/list-crown-target.component";
import { AppTicketingComponent } from "../app-ticketing/app-ticketing.component";
import { EditTicketComponent } from "../app-ticketing/edit-ticket/edit-ticket.component";
import { AppSchedularComponent } from "../app-schedular/app-schedular.component";
import { ImageConfigurationComponent } from "../masterData/image-configuration/image-configuration.component";
import { DataRefreshComponent } from "../data-refresh/data-refresh.component";
import { CoolerRejectionReasonComponent } from "../visibility/chiller/cooler-rejection-reason/cooler-rejection-reason.component";
import { GapAnalysisReportComponent } from "../gap-analysis-report/gap-analysis-report.component";
import { MakerCheackerConfigurationComponent } from "../masterData/maker-cheacker-configuration/maker-cheacker-configuration.component";
import { AutoMigrateUsersComponent } from "../auto-migrate-users/auto-migrate-users.component";
import { CreateCartonComponent } from "../carton/create-carton/create-carton.component";
import { WhitelistOutletsComponent } from "../carton/whitelist-outlets/whitelist-outlets.component";
import { CartonStepsComponent } from "../carton/carton-steps/carton-steps.component";
import { CartonUploadComponent } from "../carton/carton-upload/carton-upload.component";
// import { QrDownloadComponent } from '../carton/qr-download/qr-download.component';
import { CartonInsertReportComponent } from "../reports/carton-insert-report/carton-insert-report.component";
import { OutletMasterReportComponent } from "../reports/outlet-master-report/outlet-master-report.component";
import { OtpSmsConsumptionComponent } from "../reports/otp-sms-consumption/otp-sms-consumption.component";
import { PointsLedgerReportComponent } from "../reports/points-ledger-report/points-ledger-report.component";
import { UserLoginHistoryReportComponent } from "../reports/user-login-history-report/user-login-history-report.component";
import { OutletOnboardingComponent } from "../userManagement/outlet-onboarding/outlet-onboarding.component";
import { CrownListComponent } from "../crown-collection/crown-list/crown-list.component";
import { CrownSetupComponent } from "../crown-collection/crown-setup/crown-setup.component";
import { CrownUploadExcelComponent } from "../crown-collection/crown-upload-excel/crown-upload-excel.component";
import { CashbackReportComponent } from "../cashback-report/cashback-report.component";
import { CashbackStepsComponent } from "../cashback-report/cashback-steps/cashback-steps.component";
import { WhitelistComponent } from "../cashback-report/whitelist/whitelist.component";
import { UpiListComponent } from "../upi-list/upi-list.component";
import { QrDownloadComponent } from "../carton/qr-download/qr-download.component";
import { RewardBifurcationComponent } from "../carton/reward-bifurcation/reward-bifurcation.component";
import { Type2CreateComponent } from "../carton/type2-create/type2-create.component";
import { SettingsComponent } from "../masterData/settings/settings.component";
import { FaqsComponent } from "../masterData/faqs/faqs.component";
import { TypeRewardsComponent } from "../masterData/type-rewards/type-rewards.component";
// import { CampaignComponent } from "../Engagement/campaign/campaign/campaign.component";
// import { EngagementDashboardComponent } from "../Engagement/engagement-config/engagement-dashboard/engagement-dashboard.component";
// import { EngagementConfigComponent } from "../Engagement/engagement-config/engagement-config.component";
// import { ContentAndLearningComponent } from "../Engagement/content-and-learning/content-and-learning.component";
// import { AddContentAndLearningComponent } from "../Engagement/content-and-learning/add-content-and-learning/add-content-and-learning.component";
import { WhitelistUsersComponent } from "../schemes/whitelist-users/whitelist-users.component";
import { ViewSingleSchemeComponent } from "../schemes/view-single-scheme/view-single-scheme.component";
import { SchemeSetupComponent } from "../schemes/scheme-setup/scheme-setup.component";
import { SchemeExcelUploadComponent } from "../schemes/scheme-excel-upload/scheme-excel-upload.component";
import { BrandHubComponent } from "../brand-hub/brand-hub/brand-hub.component";
import { BrandHubStepsComponent } from "../brand-hub/brand-hub-steps/brand-hub-steps.component";
import { RewardsComponent } from "../Reward/rewards/rewards.component";
import { RewardSetupComponent } from "../Reward/reward-setup/reward-setup.component";
import { BannerComponent } from "../masterData/banner/banner.component";
import { TargetSetComponent } from "../target-set/target-set.component";
import { ReportModuleComponent } from "../report-module/report-module.component";
import { TargetDeleteComponent } from "../deletion/target-delete/target-delete.component";
import { DeleteAchievementComponent } from "../deletion/delete-achievement/delete-achievement.component";
import { PointsAllocationComponent } from "../deletion/points-allocation/points-allocation.component";
import { PointsCalculationComponent } from "../deletion/points-calculation/points-calculation.component";
import { UserProfileComponent } from "../user-profile/user-profile.component";
import { BonusPointsConfigComponent } from "../bonus-points-config/bonus-points-config.component";
import { AddBonusPointsComponent } from "../add-bonus-points/add-bonus-points.component";
import { BonusSchemeMakerchekerComponent } from "../bonus-scheme-makercheker/bonus-scheme-makercheker.component";
import { NotificarionComponent } from "../comm-matrix/push-notification/notificarion/notificarion.component";
import { NotificationComponent } from "../comm-matrix/sms-notification/notification/notification.component";
import { TriggerNotificationComponent } from "../comm-matrix/trigger-notification/trigger-notification.component";

//New Engagement
import { ImageTaskListComponent } from "../engagement/image-task/image-task-list/image-task-list.component";
import { QuizTaskListComponent } from "../engagement/quiz-task/quiz-task-list/quiz-task-list.component";
import { ContentAndLearingListComponent } from "../engagement/content-and-learning/content-and-learing-list/content-and-learing-list.component";
import { ContentAndLearingSetupComponent } from "../engagement/content-and-learning/content-and-learing-setup/content-and-learing-setup.component";
import { QuizTaskSetupComponent } from "../engagement/quiz-task/quiz-task-setup/quiz-task-setup.component";
import { ImageTaskSetupComponent } from "../engagement/image-task/image-task-setup/image-task-setup.component";
import { ContentAndLearingExcelUploadComponent } from "../engagement/content-and-learning/content-and-learing-excel-upload/content-and-learing-excel-upload.component";
import { QuizTaskExcelUploadComponent } from "../engagement/quiz-task/quiz-task-excel-upload/quiz-task-excel-upload.component";
import { ImageTaskExcelUploadComponent } from "../engagement/image-task/image-task-excel-upload/image-task-excel-upload.component";
import { ImageSubEngagementComponent } from "../engagement/image-task/image-sub-engagement/image-sub-engagement.component";

export const LayoutRoutes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      { path: "dashboard", component: DashboardComponent },
      { path: "region", component: RegionComponent },
      { path: "states", component: StatesComponent },
      { path: "cities", component: CitiesComponent },
      { path: "user-management/users", component: UsersComponent },
      {
        path: "user-management/user-profiles",
        component: UsersProfilesComponent,
      },
      {
        path: "user-management/outlet-type-hierarchy",
        component: OutletTypeHierarchyComponent,
      },
      {
        path: "user-management/geographical-hierarchy",
        component: GeographicalHierarchyComponent,
      },
      {
        path: "user-management/geo-group",
        component: GeoGroupComponent,
      },
      {
        path: "user-management/geo-user",
        component: GeoUserComponent,
      },
      {
        path: "user-management/geo-group/add-edit",
        component: GeoGroupAddEditComponent,
      },
      { path: "reports/general-reports", component: GeneralReportsComponent },
      // { path: "campaign", component: CampaignComponent },
      { path: "brands", component: BrandsComponent },
      { path: "chanel", component: ChanelComponent },
      { path: "language", component: LanguagesComponent },
      { path: "modules", component: ModulesComponent },
      { path: "units", component: UnitsComponent },
      { path: "frequency", component: FrequencyComponent },
      { path: "brand-categories", component: BrandCategoriesComponent },
      { path: "products", component: ProductsComponent },
      { path: "roles", component: RolesComponent },
      { path: "list-order", component: ListOrderComponent },
      { path: "details-order/:orderId", component: DetailsOrderComponent },
      // { path: "engagement", component: EngagementDashboardComponent },
      { path: "reward-categories", component: RewardCategoriesComponent },
      {
        path: "reward-sub-categories",
        component: RewardSubCategoriesComponent,
      },
      { path: "reward-types", component: RewardTypesComponent },
      { path: "reward-products", component: RewardProductsComponent },
      { path: "reward-history", component: RewardHistoryComponent },
      { path: "carton-list", component: CartonsListComponent },
      { path: "offer-add", component: AddOfferComponent },
      { path: "schemes-list", component: SchemesListComponent },
      { path: "visibility-list", component: VisibilityListComponent },
      { path: "campaign-creation", component: CampaignCreationComponent },
      {
        path: "visibility-config-list",
        component: VisibilityConfigListComponent,
      },
      {
        path: "cooler-config-list",
        component: CoolerConfigListComponent,
      },
      {
        path: "visibility-config-edit/:id",
        component: VisibilityConfigListComponent,
      },
      {
        path: "visibility-config-add/:id",
        component: VisibilityConfigAddComponent,
      },
      {
        path: "cooler-config-add",
        component: CoolerConfigAddComponent,
      },
      {
        path: "cooler-config-add/:id",
        component: CoolerConfigAddComponent,
      },
      {
        path: "visibility-config-add",
        component: VisibilityConfigAddComponent,
      },
      {
        path: "visibility-submissions",
        component: VisibilitySubmissionsComponent,
      },
      {
        path: "visibility-element-add",
        component: VisibilityElementAddComponent,
      },
      {
        path: "visibility-element-edit/:id",
        component: VisibilityElementEditComponent,
      },
      // VisibilityElementAddComponent
      { path: "edit-user/:userId", component: EditUserComponent },
      { path: "create-user", component: CreateUserComponent },
      { path: "product-edit/:id", component: ProductEditComponent },
      { path: "carton-codes/:id", component: CartonCodesComponent },
      { path: "offer-list", component: ListOfferComponent },
      { path: "list-category", component: ListCategoryComponent },
      { path: "edit-category", component: EditCategoryComponent },
      {
        path: "list-target-achievements",
        component: ListTargetAchievementsComponent,
      },
      {
        path: "add-target-achievements",
        component: AddTargetAchievementsComponent,
      },
      // { path: "add_engagement", component: EngagementConfigComponent },
      { path: "create-reward-product", component: CreateProductComponent },
      { path: "edit-reward-product/:prodId", component: EditProductComponent },
      {
        path: "scheme-configuration/:id",
        component: SchemeConfigurationComponent,
      },
      { path: "product-add", component: ProductAddComponent },
      { path: "add-offer", component: AddOfferComponent },
      // {
      //   // path: "content-and-learning_dashboard",
      //   // component: ContentAndLearningComponent,
      // },
      // {
      //   // path: "content-and-learning",
      //   // component: AddContentAndLearningComponent,
      // },
      { path: "get-beats", component: GetBeatsComponent },
      { path: "get-visits/:id", component: GetVisitsComponent },
      { path: "create-visits", component: CreateVisitsComponent },
      { path: "get-enrollments", component: GetEnrollmentComponent },
      { path: "enroll-user", component: EnrollUserComponent },
      { path: "edit-category/:id", component: EditCategoryComponent },
      { path: "add-category", component: AddCategoryComponent },
      { path: "create-enroll", component: CreateEnrollmentComponent },
      { path: "view-enroll", component: ViewEnrollmentComponent },
      { path: "whitelisting", component: WhitelistingComponent },
      { path: "update-offer", component: UpdateOfferComponent },
      { path: "user-points", component: UserPointsComponent },
      {
        path: "visibility-chiller-selection",
        component: ChillerSelectionComponent,
      },
      {
        path: "visibility-chiller-rejection",
        component: CoolerRejectionReasonComponent,
      },
      {
        path: "visibility-chiller-scheme",
        component: ChillerSchemeComponent,
      },
      {
        path: "add-edit-chiller-scheme/:id",
        component: AddChillerSchemeComponent,
      },
      {
        path: "visibility-audit-types",
        component: VisiblityAuditTypesComponent,
      },
      {
        path: "visibility-template/:id",
        component: AddEditVisiblityTemplateComponent,
      },
      {
        path: "cooler-template/:id",
        component: AddEditCoolerAuditTypeComponent,
      },
      {
        path: "cooler-element",
        component: CoolerElementsComponent,
      },
      {
        path: "cooler-templates",
        component: CoolerAuditTypesComponent,
      },
      {
        path: "user-report",
        component: GeneralReportsComponent,
      },
      {
        path: "mobile-change-report",
        component: MobileChangeReportComponent,
      },
      {
        path: "enrollment-detailed-report",
        component: EnrollementDetailedReportComponent,
      },
      {
        path: "report-home",
        component: HomeComponent,
      },
      {
        path: "account-statement",
        component: AccountStatementComponent,
      },
      {
        path: "bud4trade-report",
        component: Bud4tradeReportComponent,
      },
      {
        path: "mystery-report",
        component: MysteryReportComponent,
      },
      {
        path: "redmeption-report",
        component: RedmeptionReportComponent,
      },
      {
        path: "target-achievement-report",
        component: TargetAchivementsReportComponent,
      },
      {
        path: "complied-state-report",
        component: CompiledStatewiseReportComponent,
      },
      {
        path: "end-of-month-report",
        component: EndOfReportComponent,
      },
      {
        path: "dau-time-report",
        component: DauReportComponent,
      },
      {
        path: "engagement-time-report",
        component: EngagementReportComponent,
      },
      {
        path: "mau-time-report",
        component: MauTimeReportComponent,
      },
      {
        path: "module-time-report",
        component: ModuleTimeReportComponent,
      },
      {
        path: "scheme-report",
        component: SchemeReportComponent,
      },
      {
        path: "uplift-report",
        component: UpliftReportComponent,
      },
      {
        path: "leaderborad-report",
        component: LeaderReportComponent,
      },
      {
        path: "other-report",
        component: OtherReportComponent,
      },
      {
        path: "live-report",
        component: LivepointReportComponent,
      },
      {
        path: "enagement-statement",
        component: EngagementStatementReportComponent,
      },
      {
        path: "redemption-hub-report",
        component: HubRedemptionReportComponent,
      },
      {
        path: "point-statement-report",
        component: PointAccountStatementComponent,
      },
      {
        path: "point-expiry-rules",
        component: PointExpiryRulesComponent,
      },
      {
        path: "add-edit-point-expiry-rule/:id",
        component: AddEditPointExpiryRuleComponent,
      },
      {
        path: "gap-analysis",
        component: GapAnalysisComponent,
      },
      {
        path: "gap-analysis-new-user",
        component: GapAnalysisNewUserComponent,
      },
      {
        path: "menu-spoc-email",
        component: MenuSpocEmailComponent,
      },
      {
        path: "create-mystery-shopper",
        component: CreateMysteryShopperComponent,
      },
      {
        path: "mystery-shopper-campaign",
        component: MysteryshopperWhitelistOutletsComponent,
      },
      {
        path: "assign-mystery-shopper",
        component: MysteryshopperWhitelistOutletsComponent,
      },
      {
        path: "mystery-shopper-templates",
        component: MysteryshopperTemplatesComponent,
      },
      {
        path: "mystery-shopper-question-bank",
        component: MysteryshopperQuestionBankComponent,
      },
      {
        path: "add-edit-mystery-campaign/:id",
        component: AddEditComponent,
      },
      {
        path: "add-edit-mystery-template/:id",
        component: AddEditTemplatesComponent,
      },
      {
        path: "list-crown-target",
        component: ListCrownTargetComponent,
      },
      {
        path: "add-crown-target/:id",
        component: AddCrownTargetComponent,
      },
      { path: "imageurls", component: ImageurlsComponent },
      { path: "ticketing", component: AppTicketingComponent },
      { path: "edit-ticketing", component: EditTicketComponent },
      { path: "schedular", component: AppSchedularComponent },
      { path: "image-config", component: ImageConfigurationComponent },
      { path: "Data-refresh", component: DataRefreshComponent },
      { path: "gap-analysis-report", component: GapAnalysisReportComponent },
      { path: "", redirectTo: "region", pathMatch: "full" },
      {
        path: "maker-cheker-config",
        component: MakerCheackerConfigurationComponent,
      },
      {
        path: "auto-migrate-users-component",
        component: AutoMigrateUsersComponent,
      },
      {
        path: "create-carton",
        component: CreateCartonComponent,
      },
      {
        path: "whitelist-outlet",
        component: WhitelistOutletsComponent,
      },
      {
        path: "carton-steps/:id/:cartonid",
        component: CartonStepsComponent,
      },
      {
        path: "carton-upload/:id/:caplimt/:cartonid",
        component: CartonUploadComponent,
      },
      {
        path: "qr-download",
        component: QrDownloadComponent,
      },
      {
        path: "carton-insert-report",
        component: CartonInsertReportComponent,
      },
      {
        path: "outlet-master-report",
        component: OutletMasterReportComponent,
      },
      {
        path: "otp-sms-consumption",
        component: OtpSmsConsumptionComponent,
      },
      {
        path: "points-ledger-report",
        component: PointsLedgerReportComponent,
      },
      {
        path: "user-login-history-report",
        component: UserLoginHistoryReportComponent,
      },
      {
        path: "user-management/outlet-onboarding",
        component: OutletOnboardingComponent,
      },
      {
        path: "crown-list",
        component: CrownListComponent,
      },
      {
        path: "crown-setup/:campaign_id",
        component: CrownSetupComponent,
      },
      {
        path: "crown-upload-excel/:id",
        component: CrownUploadExcelComponent,
      },
      {
        path: "cashback-report",
        component: CashbackReportComponent,
      },
      {
        path: "cashback-steps/:data",
        component: CashbackStepsComponent,
      },
      {
        path: "upiList",
        component: UpiListComponent,
      },
      {
        path: "carton-steps/:id/:cartonid/:type",
        component: CartonStepsComponent,
      },
      {
        path: "reward-bifurcation",
        component: RewardBifurcationComponent,
      },
      {
        path: "carton-create-type2",
        component: Type2CreateComponent,
      },
      {
        path: "settings",
        component: SettingsComponent,
      },
      {
        path: "faqs",
        component: FaqsComponent,
      },
      {
        path: "types-of-rewards",
        component: TypeRewardsComponent,
      },
      // {
      //   path: "campaign",
      //   component: CampaignComponent,
      // },
      { path: "scheme-configuration", component: SchemeConfigurationComponent },
      { path: "Whitelistusers/:id", component: WhitelistUsersComponent },
      { path: "view-scheme/:id", component: ViewSingleSchemeComponent },
      { path: "scheme-setup/:id", component: SchemeSetupComponent },
      {
        path: "scheme-excel-upload/:id/:step_id",
        component: SchemeExcelUploadComponent,
      },
      { path: "brand-hub", component: BrandHubComponent },
      {
        path: "brand-hub-setup/:brandhubID",
        component: BrandHubStepsComponent,
      },
      { path: "Rewards", component: RewardsComponent },
      { path: "reward-setup/:rewardID", component: RewardSetupComponent },
      { path: "banner", component: BannerComponent },
      { path: "target-set", component: TargetSetComponent },
      { path: "report", component: ReportModuleComponent },
      { path: "target-delete", component: TargetDeleteComponent },
      { path: "achievement-delete", component: DeleteAchievementComponent },
      { path: "points-calculation", component: PointsCalculationComponent },
      { path: "points-allocation", component: PointsAllocationComponent },
      { path: "user-profile", component: UserProfileComponent },
      { path: "bonus-points-config", component: BonusPointsConfigComponent },
      { path: "add-bonus-points", component: AddBonusPointsComponent },
      { path: "bonus-points-schem-maker-checker", component: BonusSchemeMakerchekerComponent },
      { path: 'push-notification', component: NotificarionComponent },
      { path: 'sms-notification', component: NotificationComponent },
      { path: 'trigger-notification', component: TriggerNotificationComponent },

      //New Engagement
      { path: 'image-task', component: ImageTaskListComponent },
      { path: 'quiz-task', component: QuizTaskListComponent },
      { path: 'content-and-learnings', component: ContentAndLearingListComponent },

      { path: 'content-and-learnings-setup/:engegement_id', component: ContentAndLearingSetupComponent },
      { path: 'quiz-task-setup/:engegement_id', component: QuizTaskSetupComponent },
      { path: 'image-task-setup/:engegement_id', component: ImageTaskSetupComponent },
      {
        path: 'content-and-learnings-excel-upload/:task_id/:engagement_type',
        component: ContentAndLearingExcelUploadComponent
      },
      {
        path: 'quiz-task-setup-excel-upload/:task_id/:engagement_type',
        component: QuizTaskExcelUploadComponent
      },
      {
        path: 'image-task-setup-excel-upload/:task_id/:engagement_type',
        component: ImageTaskExcelUploadComponent
      },
      {
        path: 'image-sub-engagement/:sub_task_id',
        component: ImageSubEngagementComponent
      },

    ],
  },
];
